import React, { PureComponent } from 'react';
import { theme, css, isMVP } from 'constants';
import { Text, View, Avatar, Alert, TimeStamp, TooltipWrapper, Clipboard, AdminBadge, MediaViewer } from 'core';
import { SYS_MSG, MEMBER_COLOR, USER_MSG_TYPES as TYPES } from 'constants';
import { isMyMessage, isDeletedMsg } from 'selectors';
import { lang } from 'lang';
import { Contact, TextMsg, DeletedMsg, Upload, PhotoMsg, Location, VideoMsg } from './msgs';
import * as actions from 'actions';

let styles = css({
  row: {
    flexDirection: 'row',
    flex: 1
  },
  my_row: {
    //alignSelf: 'flex-end',
    //flexDirection: 'row-reverse',
    //alignItems: 'flex-start'
  },
  content: {
    flex: 0.7,
    flexDirection: 'row',
    alignItems: 'flex-end',
    overflow: 'visible',
    marginHorizontal: 5
  },
  my_content: {
    justifyContent: 'flex-end'
  },
  msg: {
    maxWidth: '100%',
    borderWidth: theme.hairline,
    borderRadius: 15,
    borderColor: theme.gray_color_lighten(0.1),
    backgroundColor: theme.gray_color_lighten(0.1),
    overflow: 'hidden',
    margin: 5
  },
  my_msg: {
    borderColor: theme.primary_color_lighten(),
    backgroundColor: theme.primary_color_lighten()
  },
  msg_selected: {
    backgroundColor: theme.gray_color_lighten(0.2)
  },
  my_msg_selected: {
    backgroundColor: theme.primary_color_lighten(0.4)
  },
  sender_info: {
    color: '#999',
    padding: 7
  },
  time: {
    position: 'absolute',
    paddingHorizontal: 7,
    bottom: 3,
    right: 3
  },
  time_bg: {
    backgroundColor: theme.gray_color_alpha(0.4),
    paddingVertical: 3,
    borderRadius: 20
  },
  alone_msg: {
    marginVertical: 5
  },
  first_msg: {
    marginTop: 5,
    marginBottom: 1,
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 15,
    borderBottomRightRadius: 15,
    borderTopRightRadius: 15
  },
  my_first_msg: {
    borderBottomLeftRadius: 15,
    borderTopLeftRadius: 15,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 15
  },
  middle_msg: {
    marginVertical: 1,
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 15,
    borderTopRightRadius: 15
  },
  my_middle_msg: {
    borderBottomLeftRadius: 15,
    borderTopLeftRadius: 15,
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0
  },
  last_msg: {
    marginBottom: 5,
    marginTop: 1,
    borderBottomLeftRadius: 15,
    borderTopLeftRadius: 0,
    borderBottomRightRadius: 15,
    borderTopRightRadius: 15
  },
  my_last_msg: {
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    borderTopRightRadius: 0
  }
});

const createUserMsg = Comp =>
  class extends PureComponent {
    render() {
      const { is_group, current_msg, next_msg, prev_msg, is_admin, is_msg_admin, member_order, name, photo } = this.props;
      const is_own = isMyMessage(current_msg);
      const current_msg_user_id = current_msg.user.id;
      const next_msg_user_id = next_msg && !SYS_MSG[next_msg.type] ? next_msg.user.id : null;
      const prev_msg_user_id = prev_msg && !SYS_MSG[prev_msg.type] ? prev_msg.user.id : null;

      const alone_msg = current_msg_user_id !== next_msg_user_id && current_msg_user_id !== prev_msg_user_id && 'alone_msg';
      const first_msg = current_msg_user_id === next_msg_user_id && current_msg_user_id !== prev_msg_user_id && 'first_msg';
      const middle_msg = current_msg_user_id === next_msg_user_id && current_msg_user_id === prev_msg_user_id && 'middle_msg';
      const last_msg = current_msg_user_id === prev_msg_user_id && current_msg_user_id !== next_msg_user_id && 'last_msg';
      const msg_type = alone_msg || first_msg || middle_msg || last_msg;

      const msg_style = styles[msg_type];
      const my_msg_style = is_own && styles['my_' + msg_type];
      const is_deleted_msg = isDeletedMsg(current_msg);

      let delete_options = [{ text: lang.DELETE_FOR_ME, onPress: () => actions.sendDeleteMsg({ msg_id: current_msg.id }) }];
      is_own && delete_options.push({ text: lang.DELETE_FOR_EVERYONE, onPress: () => actions.sendDeleteMsg({ msg_id: current_msg.id, is_for_all: true }) });
      delete_options.push({ text: lang.CANCEL });
      let options;
      if (is_deleted_msg || current_msg.type === TYPES.DELETED) {
        if (is_group && !is_own) {
          options = [{ text: `${lang.SEND_TO} ${current_msg.user.name.split(' ')[0]}`, onPress: () => console.log('bla') }];
        } else {
          options = [];
        }
      } else {
        options = [{ text: lang.COPY, onPress: () => Clipboard.setString(current_msg.text) }];
        is_admin && !isMVP && options.unshift({ text: lang.PIN, onPress: () => console.log('bla') });
        !isMVP && (options = options.concat([{ text: lang.REPLY, onPress: () => console.log('bla2') }, { text: lang.FORWARD, onPress: () => console.log('forward') }]));
        is_group && !is_own && options.push({ text: `${lang.SEND_TO} ${current_msg.user.name.split(' ')[0]}`, onPress: () => console.log('bla') });
        is_own && !isMVP && options.push({ text: lang.IS_EN ? lang.INFO : lang.MORE, onPress: () => console.log('bla') });
        options.push({ text: lang.DELETE, onPress: () => Alert.alert(lang.DELETE_MSG, '', delete_options) });
      }
      const current_msg_user = current_msg.user;
      current_msg_user.photo = photo;

      const is_timestamp_bg = current_msg.type === 'PHOTO' || current_msg.type === 'VIDEO';
      return (
        <View>
          <View style={[styles.row, is_own && styles.my_row]}>
            {is_own ? <View style={{ flex: 0.3 }} /> : null}
            <View style={[styles.content, is_own && styles.my_content]}>
              {!is_own && is_group ? last_msg || alone_msg ? <Avatar data={current_msg_user} size={35} /> : <View style={{ width: 35 }} /> : null}
              <TooltipWrapper
                options={options}
                is_right={is_own}
                style={[styles.msg, is_own && styles.my_msg, msg_style, my_msg_style]}
                selected_style={is_own ? styles.my_msg_selected : styles.msg_selected}
                onPress={msg_press[current_msg.type] && msg_press[current_msg.type](current_msg)}
              >
                {!is_own && is_group
                  ? (first_msg || alone_msg) && (
                      <View style={{ alignItems: 'center', flexDirection: 'row' }}>
                        <Text style={[styles.sender_info, { color: MEMBER_COLOR[(member_order || 0) % MEMBER_COLOR.length] }]}>{name}</Text>
                        <AdminBadge is_admin={is_msg_admin} />
                      </View>
                    )
                  : null}

                {is_deleted_msg ? <DeletedMsg is_for_me={true} /> : <Comp current_msg={current_msg} />}

                <View style={[styles.time, is_timestamp_bg && styles.time_bg]}>
                  <TimeStamp style={is_timestamp_bg && { color: 'white' }} value={current_msg.created} only_time />
                </View>
                {/* This view to ensure minumme width of 50*/}
                <View style={{ width: 50, height: 0 }} />
              </TooltipWrapper>
            </View>
            {/* {!is_own && <View style={{ flex: 0.3 }} />} */}
          </View>
        </View>
      );
    }
  };

const msg_press = {
  [TYPES.PHOTO]: current_msg => () =>
    MediaViewer.show({
      upload: { file_id: current_msg.id, user_id: current_msg.user.id },
      asset_type: 'PHOTO',
      size: { width: current_msg.data.width, height: current_msg.data.height },
      color: current_msg.data.color
    }),
  [TYPES.VIDEO]: current_msg => () =>
    MediaViewer.show({
      upload: { file_id: current_msg.id, user_id: current_msg.user.id, ext: current_msg.data.ext },
      asset_type: 'VIDEO',
      size: { width: current_msg.data.width, height: current_msg.data.height }
    })
};

const user_types = {
  [TYPES.CONTACT]: createUserMsg(Contact),
  [TYPES.LOCATION]: createUserMsg(Location),
  [TYPES.TEXT]: createUserMsg(TextMsg),
  [TYPES.DELETED]: createUserMsg(DeletedMsg),
  [TYPES.UPLOAD]: createUserMsg(Upload),
  [TYPES.PHOTO]: createUserMsg(PhotoMsg),
  [TYPES.VIDEO]: createUserMsg(VideoMsg)
};

export default user_types;



// WEBPACK FOOTER //
// ./src/components/middle/chat/user_msg.js